/**
 * Copyright (c) 2022 Animation Studio Voronezh.
 *
 * CONFIDENTIAL AND PROPRIETARY
 *
 * This work is provided "AS IS" and subject to the Prodtrack
 * Source Code License. By accessing, using, copying or modifying
 * this work you indicate your agreement to the Prodtrack Source Code License.
 * All rights not expressly granted therein are reserved by Animation Studio Voronezh.
 */

import React, { useState } from "react";
import { toast } from "react-toastify";
import defaultRequest from "services/api";
import { useEffect, useRef } from "react";
import { initState } from "../initState";

const postBgJobsProgress = ({ taskIDs }) =>
    defaultRequest.post("/api/v1/background_jobs_progress/", {
        task_ids: taskIDs,
    });

const stateLogger = ({ stateData, action, intervalTime }) => {
    const intervalIdRef = useRef(null);

    useEffect(() => {
        if (intervalIdRef.current) clearInterval(intervalIdRef.current);

        action();
        intervalIdRef.current = setInterval(() => action(), intervalTime);

        return () => clearInterval(intervalIdRef.current);
    }, [stateData.celeryTaskIDArray]);

    useEffect(() => {
        if (getNotFinishedTasks(stateData.detailedTasks).length === 0) {
            clearInterval(intervalIdRef.current);
        }
    }, [stateData.detailedTasks]);
};

const getNotFinishedTasks = (detailedTasks) => {
    return detailedTasks.filter(
        (task) => !(task.status === "SUCCESS" && task.done === task.total)
    );
};

const useCeleryProgressData = () => {
    const [value, setValue] = React.useState(initState);

    stateLogger({
        stateData: value,
        intervalTime: 5000,
        action: () =>
            postBgJobsProgress({
                taskIDs: value.celeryTaskIDArray,
            }).then((res) => {
                setValue({ ...value, detailedTasks: res.data });
            }),
    });

    const [completedTaskIDs, setCompletedTaskIDs] = useState(() => new Set());

    const addCompletedTaskID = (taskID) =>
        setCompletedTaskIDs((prev) => prev.add(taskID));

    useEffect(() => {
        value.detailedTasks.map((task) => {
            if (task.status === "SUCCESS") {
                if (task.done < task.total) {
                    toast.update(task.main_task_id, {
                        render: `Task is in progress: ${task.percent}`,
                        type: "info",
                        progress: task.done / task.total,
                    });
                } else if (task.done === task.total) {
                    if (!completedTaskIDs.has(task.main_task_id)) {
                        toast.update(task.main_task_id, {
                            render: "Task is completed",
                            type: "success",
                            progress: null,
                            autoClose: 3000,
                        });
                        addCompletedTaskID(task.main_task_id);
                    }
                }
            } else if (task.status === "PENDING" && task.ready === false) {
                toast.update(task.main_task_id, {
                    render: "Task is in queue",
                    type: "default",
                });
            }
        });

        return () => {
            console.log("Action");
        };
    }, [value.detailedTasks]);

    return { value, setValue };
};

export default useCeleryProgressData;
